import { useMutation, useQueryClient } from "@tanstack/react-query";
import useAuthenticatedApiRequest from "../../AuthenticatedApiRequest";
import TchrURL from "../../TchrURL";
import { useInvalidateUserStats } from "../user/useUserStats";

const useCheckoutComplete = ({ sessionId }: { sessionId: string }) => {
  const { post } = useAuthenticatedApiRequest();
  const queryClient = useQueryClient();
  const invalidateUserStats = useInvalidateUserStats();

  return useMutation({
    mutationKey: ["checkout", "complete"],
    mutationFn: async () => {
      const searchParams = new URLSearchParams();
      searchParams.append("sessionId", sessionId);
      const url = new TchrURL("/payment/checkoutcomplete");
      url.search = searchParams.toString();
      const response = await post(url, "");
      return response.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["user"] });
      invalidateUserStats();
    },
  });
};

export default useCheckoutComplete;
